import React from "react";
import Card from 'react-bootstrap/Card';
import { useNavigate } from "react-router-dom";

const Admin = () => {

    const navigate = useNavigate(); 
    const routeChange = (route) =>{ 
        navigate(route);
    }

    return (
        <div className="container admin">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-4">
                    <Card onClick={() => routeChange('/peticiones_pendientes')} style={{cursor: "pointer"}} className="text-center admin-card" bg="light">
                    <Card.Body className="card-body">
                        <Card.Title>Vacaciones pendientes</Card.Title>
                    </Card.Body>
                    </Card>
                    </div>
                    <div className="col-md-4">
                    <Card onClick={() => routeChange('/formulario_dias')} style={{cursor: "pointer"}} className="text-center admin-card" bg="light">
                    <Card.Body>
                        <Card.Title>Dar días de vacaciones</Card.Title>
                    </Card.Body>
                    </Card>
                    </div>
                    <div className="col-md-4">
                    <Card onClick={() => routeChange('/lista_empleados')} style={{cursor: "pointer"}} className="text-center admin-card" bg="light">
                    <Card.Body>
                        <Card.Title>Listado de empleados</Card.Title>
                    </Card.Body>
                    </Card>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                    <Card onClick={() => routeChange('/formulario_usuarios')} style={{cursor: "pointer"}} className="text-center admin-card" bg="light">
                    <Card.Body>
                        <Card.Title>Buscar empleado</Card.Title>
                    </Card.Body>
                    </Card>
                    </div>
                    <div className="col-md-4">
                    <Card onClick={() => routeChange('/formulario_festivos')} style={{cursor: "pointer"}} className="text-center admin-card" bg="light">
                    <Card.Body>
                        <Card.Title>Crear día festivo</Card.Title>
                    </Card.Body>
                    </Card>
                    </div>
                    <div className="col-md-4">
                    <Card onClick={() => routeChange('/dias_festivos')} style={{cursor: "pointer"}} className="text-center admin-card" bg="light">
                    <Card.Body>
                        <Card.Title>Listado de festivos</Card.Title>
                    </Card.Body>
                    </Card>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                    <Card onClick={() => routeChange('/formulario_responsables')} style={{cursor: "pointer"}} className="text-center admin-card" bg="light">
                    <Card.Body>
                        <Card.Title>Asignar responsables</Card.Title>
                    </Card.Body>
                    </Card>
                    </div>
                    <div className="col-md-4">
                    <Card onClick={() => routeChange('/configuracion_responsable')} style={{cursor: "pointer"}} className="text-center admin-card" bg="light">
                    <Card.Body>
                        <Card.Title>Responsable por defecto</Card.Title>
                    </Card.Body>
                    </Card>
                    </div>
                    <div className="col-md-4">

                    </div>
                </div>
            </div>
        </div>
    );
}


export default Admin;